import { Stack } from "@mui/system"
import { makeStyles } from "tss-react/mui"
import { ImportFormSettingsPanelContent } from "../../../../../../shared/components/importCsv/ImportFormSettingsPanelContent"
import { StandardMainPanel } from "../../../../../../shared/components/forms/StandardMainPanel"
import { StandardSidePanel } from "../../../../../../shared/components/forms/StandardSidePanel"
import { StandardForm } from "../../../../../../shared/components/forms/StandardForm"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { SelectUserGroupDropdown } from "./SelectUserGroupDropdown"
import { SelectUpdateKeyDropdown } from "./SelectUpdateKeyDropdown"
import { ImportFile } from "./ImportFile"

const useStyles = makeStyles()((theme) => ({
    box: {
        maxWidth: "18.75rem",
    },
}))

type ImportIdCardsFormContentProps = Readonly<{}>

export function ImportIdCardsFormContent({}: ImportIdCardsFormContentProps) {
    const { classes } = useStyles()

    return (
        <>
            <StandardForm>
                <StandardMainPanel>
                    <Stack direction="column" spacing="1.5rem" className={classes.box}>
                        <SelectUserGroupDropdown />
                        <SelectUpdateKeyDropdown />
                    </Stack>
                    <ImportFile />
                </StandardMainPanel>
                <LocalizedStrict id="data-import-csv-settings" attrs={{ title: true }}>
                    <StandardSidePanel title="Settings" variant="collapsible">
                        <ImportFormSettingsPanelContent />
                    </StandardSidePanel>
                </LocalizedStrict>
            </StandardForm>
        </>
    )
}
